import React, { useCallback, useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Variables } from "../../Variations/Variations";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { AiOutlineRight } from "react-icons/ai";
import Cookies from "js-cookie";
import { Button } from "react-bootstrap";
const AddMedia = () => {
  //# region variables
  const [media, setMedia] = useState([]);
  const token = Cookies.get("UserToken");
  const navigate = useNavigate();
  //# end region variables

  const [uploadedImages, setUploadedImages] = useState([]);
  //# handle

  const handleDrop = async (files) => {
    const token = Cookies.get("UserToken");
    let count = 0;
  
    for (let file of files) {
      if (file.size >= 2000000) {
        count++;
      } else {
        const formData = new FormData();
        formData.append("Image", file);
  
        try {
          const res = await axios.post(
            Variables.API_URL + "UploadMedia/UploadImageToServer",
            formData,
            {
              headers: {
                "Authorization": `Bearer ${token}`,
              },
            }
          );
  
          if (res.data) {
            // Add to local state so we can show & edit alt before saving to DB
            setUploadedImages(prev => [
              ...prev,
              {
                imagePath: res.data, // server path returned
                alt: "",
                imageTitle: file.name.split(".").slice(0, -1).join(".")
              }
            ]);
  
            console.log("Image uploaded successfully:", res.data);
          }
        } catch (ex) {
          console.log(ex);
        }
      }
    }
  
    if (count > 0) {
      toast.error(`${count} image(s) not accepted (over 2MB)`);
    }
  };

  // Update alt text for an uploaded image
    const handleAltChange = (index, value) => {
      setUploadedImages(prev => {
        const updated = [...prev];
        updated[index].alt = value;
        return updated;
      });
    };
  
    // Save all uploaded images with alt text
    const saveUploadedImages = async () => {
      const token = Cookies.get("UserToken");
    
      for (let img of uploadedImages) {
        await fetch(Variables.API_URL + "UploadMedia/InsertMedia", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            image: img.imagePath,
            imageTitle: img.imageTitle,
            altText: img.alt,
            description: "",
            caption: "",
          }),
        });
      }
    
      toast.success("Images saved successfully!");
      setUploadedImages([]); // clear temporary list
    };

  useEffect(() => {
    if(Cookies.get("UserToken") === undefined){
      navigate("/Login")
    }
  }, []);

  return (
    <div className="rightSide">
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="container-fluid mt-3">
          <div className="row">
            <div className="col-12">
              <h2>Upload Media</h2>
              <ul className="portalPath">
                <li>Home <AiOutlineRight /></li>
                <li><Link to="/Media">Media <AiOutlineRight /></Link></li>
                <li>Upload Media</li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="mb-3 text-right">
                    <NavLink to="/Media" className="btn btn-secondary">
                      Back
                    </NavLink>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <section className="container"></section>
                      <div className="row mt-3">
                        <Dropzone
                          onDrop={handleDrop}
                          accept="image/jpeg,image/png,image/jpg,image/svg"
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps({ className: "dropzone p-4 border" })}>
                              <input {...getInputProps()} />
                              <p>Drag & drop images here, or click to select files</p>
                            </div>
                          )}
                        </Dropzone>
                      </div>
                      <br />
                      {/* Show uploaded images for alt editing */}
                      {uploadedImages.length > 0 && (
                        <div className="mt-4">
                          <div className="row">
                            {uploadedImages.map((img, idx) => (
                              <div key={idx} className="col-3 text-center">
                                <img
                                  src={Variables.API_PUBLISHED + img.imagePath}
                                  alt=""
                                  className="img-fluid border"
                                />
                                <input
                                  type="text"
                                  className="form-control mt-2"
                                  placeholder="Alt text"
                                  value={img.alt}
                                  onChange={(e) => handleAltChange(idx, e.target.value)}
                                />
                              </div>
                            ))}
                          </div>
                          <div className="mt-3 text-end">
                            <Button variant="primary" onClick={saveUploadedImages}>
                              Save All
                            </Button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
{
}

export default AddMedia;
